import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './RSVP.css';
import { useLanguage } from '../../context/LanguageContext';

function RSVPGuest({ guest }) {
  const { t } = useLanguage();

  // Use props from API response as source of truth
  const allowedGuests = guest.allowedGuests || 1;

  const [formData, setFormData] = useState({
    code: guest.code,
    name: guest.name,
    attending: '',
    plusOne: '', // Force selection
    drinks: 'indifferent'
  });
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const API_URL = window.location.hostname === 'localhost' ? "http://localhost:5001" : "https://esponjoboda.com";

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form data being submitted:', formData);

    try {
      const payload = {
        code: formData.code,
        name: formData.name,
        attending: formData.attending === 'yes',
        guestsNames: formData.plusOne ? [formData.plusOne] : [],
        drinks: formData.drinks
      };

      const response = await fetch(`${API_URL}/api/rsvp`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        },
        body: JSON.stringify(payload),
      });

      console.log('Response status:', response.status);
      console.log('Response ok:', response.ok);

      if (response.ok) {
        if (formData.attending === 'yes') {
          alert(t.rsvp_success + " " + t.rsvp_confirmed_yes);
        } else if (formData.attending === 'no') {
          alert(t.rsvp_confirmed_no);
        }

        setSubmitted(true);
        setTimeout(() => navigate('/'), 2000);
      } else {
        const errorData = await response.json().catch(() => ({ error: 'Error desconocido' }));
        console.error('Server error:', errorData);
        alert(`Error: ${errorData.error || 'Al enviar la confirmación'}`);
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error submitting RSVP. Please try again.');
    }
  };

  if (submitted) {
    return <div className="rsvp-container"><h2>{t.rsvp_success}</h2></div>;
  }

  const isSubmitEnabled = () => {
    if (formData.attending === 'no') return true;
    return formData.plusOne !== '' && formData.drinks !== '';
  };

  return (
    <div className="rsvp-container">
      <h2>{t.rsvp_title}</h2>
      <form onSubmit={handleSubmit} className="rsvp-form">
        <div className="form-columns">
          <div className="form-column">
            <label>
              {t.rsvp_code_title}
              <input type="text" name="code" value={formData.code} readOnly />
            </label>
            <label>
              {t.rsvp_name}
              <input type="text" name="name" value={formData.name} readOnly />
            </label>
          </div>
          <div className="form-column">
            <label>
              {t.rsvp_attending}
              <select name="attending" value={formData.attending} onChange={handleChange}>
                <option value="" disabled>{t.rsvp_default}</option>
                <option value="yes">{t.rsvp_yes}</option>
                <option value="no">{t.rsvp_no}</option>
              </select>
            </label>

            {formData.attending === 'yes' && (
              <>
                <label>
                  {t.rsvp_guests}
                  <select
                    name="plusOne"
                    value={formData.plusOne}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>{t.rsvp_default}</option>
                    {Array.from({ length: allowedGuests }, (_, i) => {
                      const count = i + 1;
                      const value = `+${i}`;
                      return (
                        <option key={i} value={value}>{count}</option>
                      );
                    })}
                  </select>
                </label>

                <label>
                  {t.rsvp_drinks}
                  <select
                    name="drinks"
                    value={formData.drinks}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>{t.rsvp_default}</option>
                    <option value="tequila">Tequila</option>
                    <option value="rum">{t.rsvp_rum}</option>
                    <option value="vodka">Vodka</option>
                    <option value="wine">{t.rsvp_wine}</option>
                    <option value="indifferent">{t.rsvp_any_drink}</option>
                  </select>
                </label>
              </>
            )}
          </div>
        </div>
        <button
          type="submit"
          className="submit-button"
          disabled={!isSubmitEnabled()}
        >
          {t.rsvp_submit}
        </button>
      </form>
    </div>
  );
}

export default RSVPGuest;
